import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import Employee from 'src/app/model/product/employee';
import { LoadingService } from '../../loading.service';
import { SnackService } from '../../snack.service';
import { Observable } from 'rxjs';
import { _get } from '../../base.service';

@Injectable({
  providedIn: 'root',
})
export class AllEmployeesControllerRequestService {
  private static BASE_URL = '/employees/allEmployees';
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;

  private readonly deserializeArray = (res) => res as Employee[];

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get(
      AllEmployeesControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public getAllEmployees(): Promise<Employee[]> {
    return this.get('', this.deserializeArray).toPromise();
  }
}
